import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getProfiles(params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get("profiles?" + parameters);
  return data;
}

export async function getEventProfiles(eventId, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(`events/${eventId}/profiles?${parameters}`);
  return data;
}

export async function getProfile(id) {
  const { data } = await axios.get("profiles/" + id + "?include=occupations");
  return data;
}

export async function createProfile(values) {
  const { data } = await axios.post("profiles", values);
  return data;
}

export async function updateProfile(id, values) {
  const { data } = await axios.patch("profiles/" + id, values);
  return data;
}

export async function deleteProfile(id) {
  const { data } = await axios.delete("profiles/" + id);
  return data;
}

export async function syncProfileOccupations(id, occupations) {
  const { data } = await axios.put(
    "profiles/" + id + "/occupations",
    occupations
  );
  return data;
}

export async function profileAttachZone(id, zone) {
  const { data } = await axios.post("profiles/" + id + "/accesses", zone);
  return data;
}

export async function profileDetachZone(id, zone) {
  const { data } = await axios.delete("profiles/" + id + "/accesses", {
    data: zone
  });
  return data;
}
